import _ from 'lodash';
import GalleryElementMetaData from './GalleryElementMetaData';
import { PADDING_PROP_NAMES } from 'crazyEditor/core/constants/panelConstants';

const presets = [
  {
    type: GalleryElementMetaData.type,
    layout: {
      x: 0,
      y: 0,
      width: 400,
      height: 400
    },
    compProps: {
      zIndex: 1,
      ..._.zipObject(PADDING_PROP_NAMES, _.times(PADDING_PROP_NAMES.length, _.constant(20)))
    },
    data: {
      list: [],
      showDottedNav: false,
      showThumbnails: true,
      alwaysShowNavArrow: false
    },
    hidden: false
  }
];

export default presets;
